import { BrowserRouter } from 'react-router-dom';

export const Public = () => {
	return (
		<BrowserRouter basename="/public">
			<h1>PUBLIC</h1>
		</BrowserRouter>
	);
}